"use client";

import React from "react";
import { DataFetchingWrapper } from "@/components/ui/data/data-fetching";
import { cn } from "@/lib/utils";

export interface ClientDetailTabDataState {
  isLoading?: boolean;
  error?: Error | null;
  isEmpty?: boolean;
  emptyMessage?: string;
  onRetry?: () => void | Promise<void>;
}

export interface ClientDetailTabProps {
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  dataState?: ClientDetailTabDataState;
}

export function ClientDetailTab({
  header,
  children,
  className,
  contentClassName,
  dataState,
}: ClientDetailTabProps) {
  const content = (
    <div className={cn(contentClassName)}>
      {children}
    </div>
  );

  return (
    <div className={cn(className)}>
      {header}
      {dataState ? (
        <DataFetchingWrapper
          isLoading={!!dataState.isLoading}
          error={dataState.error ?? null}
          isEmpty={!!dataState.isEmpty}
          emptyMessage={dataState.emptyMessage}
          onRetry={dataState.onRetry}
        >
          {content}
        </DataFetchingWrapper>
      ) : (
        content
      )}
    </div>
  );
}
